import type { SolutionSector } from "../sectors";
import { ACCURACY_QUESTION, COST_QUESTION, EFFORT_QUESTION, LOGO } from "./shared";

export const FINTECH: SolutionSector = {
  slug: "fintech",
  name: "Fintech",
  demoOrg: "Demo (FinTech)",
  story: "fintech",
  metadata: {
    title: "AI for fintech implementation reviews | Your Twin",
    description:
      "Know what is blocking each go-live. Your Twin connects HubSpot, Linear, Google Drive and Slack, so you can see open dependencies, missing evidence and owners before the next call.",
  },
  hero: {
    label: "Fintech",
    title: ["Clear what’s", "blocking each", "go-live."],
    lead: [
      "Which go-lives are blocked, and by what? Your Twin connects customers in ",
      LOGO.hubspot,
      " with tasks in ",
      LOGO.linear,
      ", checklists in ",
      LOGO.drive,
      " and conversations in ",
      LOGO.slack,
      ", each blocker beside its owner.",
    ],
    cta: "Bring a customer implementation",
    buyer: "For COOs, heads of implementation and onboarding, and customer operations directors",
    instrumentLabel: "The fintech Twin · Customer, go-live, dependency and owner",
  },
  replay: {
    title: "Which go-lives are blocked?\nAnd by what?",
    lead: "Ask across HubSpot, Linear, Google Drive and Slack. See each open dependency beside the go-live date and its recorded owner.",
  },
  outcomes: {
    title: "Every go-live, with\nits blockers in view.",
    lead: "Operations sees each go-live beside its open dependencies, its evidence and its owner.",
    items: [
      { title: "Find the blocked go-live.", body: "Bring open dependencies beside the go-live date.", show: "status" },
      { title: "Locate the missing evidence.", body: "See what the connected checklist still needs.", show: "sources" },
      { title: "Make the handover clear.", body: "Keep the recorded owner and follow-up beside the work.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose an implementation review your team prepares today." },
  questions: [
    { q: "Does this perform KYC or AML checks?", a: "No. This workflow prepares an implementation review. It doesn’t establish customer clearance or replace your compliance team." },
    {
      q: "Can we use it with regulated information?",
      a: "We agree the records, access, hosting and model processing with your team before connecting anything, and connections start read-only. Your compliance team decides what is in scope.",
    },
    {
      q: "Will it change customer or payment records?",
      a: "Connections start read-only. The Twin can suggest a next step; your team decides what happens, and this workflow changes nothing.",
    },
    ACCURACY_QUESTION,
    EFFORT_QUESTION,
    COST_QUESTION,
  ],
  closing: "Start with one go-live\nthat keeps slipping.",
};
